angular.module('impactx.approval').controller('RenameSFTController', [
    '$mdDialog',
    'dataGen',
    'TranslationService',
    RenameSFTController]);

function RenameSFTController($mdDialog, dataGen, TranslationService) {
    var self = this;
    var oldName = self.selected.internalName;
    this.trns.abort = TranslationService.get('abort');
    this.trns.save = TranslationService.get('save');
    this.hide = function() {
        $mdDialog.hide();
    };
    this.cancel = function() {
        $mdDialog.cancel();
    };
    this.rename = function() {
        dataGen.postAsForm({}, {oldName: oldName, newName: self.selected.internalName}, "/smartform/rename").then(function () {
            $mdDialog.hide(true);
        });
    };
}